<ion-item
  class="user-settings__user"
  [ngClass]="{ 'user-settings__user--mobile': mobileView }"
  lines="none"
  detail="false"
  button
  (click)="onToggleMenu()"
>
  <app-avatar [user]="userStorage"> </app-avatar>
  <ion-label *ngIf="!mobileView" class="ion-margin-start">
    <div class="user-settings__user-name">
      {{ userStorage?.firstName
      }}{{ userStorage?.lastName ? " " + userStorage.lastName : "" }}
    </div>
    <div class="user-settings__company-name">
      {{ userStorage?.company ? userStorage.company.name : "-" }}
    </div>
  </ion-label>

  <ion-icon
    [@toggleRotate]="!userSubmenuActive ? 'inactive' : 'active'"
    slot="end"
    class="user-settings__chevron-icon"
    name="chevron-down-outline"
    *ngIf="!mobileView"
  >
  </ion-icon>
</ion-item>

<div
  class="user-settings__submenu"
  [ngClass]="{ 'user-settings__submenu--active': userSubmenuActive }"
  [@toggleHeight]="userSubmenuActive ? 'active' : 'inactive'"
>
  <ion-item
    (click)="onRedirectToSettings()"
    lines="none"
    button
    *appHasRole="['my.settings']"
  >
    <ion-icon
      class="user-settings__menu-icon"
      name="settings"
      slot="start"
    ></ion-icon>
    <ion-label class="user-settings__menu-label">{{
      "MENU.SETTINGS" | translate
    }}</ion-label>
  </ion-item>

  <ion-item lines="none" button (click)="onLogout()">
    <ion-icon
      class="user-settings__menu-icon"
      name="exit"
      slot="start"
    ></ion-icon>
    <ion-label class="user-settings__menu-label">{{
      "MENU.LOG_OUT" | translate
    }}</ion-label>
  </ion-item>
</div>
